import { store } from '../store'
const BASE_URL = 'https://app.sigecor.com.br/v2'


export default {
  baseUrl: BASE_URL,
  authHeader: function () {

    const user = store.getters.getToken
    if (user) {

      return 'Bearer ' + user;
    } else {
      return {};
    }
  }
}
